export default __webpack_public_path__ + "static/18953-cef7c51ff407b2f1ba0c404e87e8bf36.jpg";